import React from 'react';
import PropTypes from 'prop-types';
import { formatTimestampToFullDate } from '../../../../../../utility/DateUtility';

/* istanbul ignore next */
function AlertRowTimestamp({ lastReadingTimestamp }) {
  const dateDisplayString = formatTimestampToFullDate(lastReadingTimestamp / 1000);

  return (
    <small>
      <span>
        {' '}
        {dateDisplayString}
        {' '}
      </span>
    </small>
  );
}

AlertRowTimestamp.propTypes = {
  lastReadingTimestamp: PropTypes.number.isRequired,
};
export default AlertRowTimestamp;
